jQuery(document).ready(function($) {

    const $postsAjax = $('.js-posts-ajax');
    const $loadMore = $postsAjax.find('.js-loadmore');
    const $postsFilter = $postsAjax.find('.js-posts-filter');
    const $filterGroups = $postsFilter.find('.js-filter-group');

    postsAjax($, $postsAjax, $postsFilter, $filterGroups, $loadMore);
    filtersAccordeons($, $postsFilter, $filterGroups);
    filtersToggle($);
    
});

function filtersToggle($) {
    const $body = $('body');
    const $toggle = $('.js-aside-toggle');

    $toggle.on('click', function (e) {
        e.preventDefault();
        $body.toggleClass('aside-active');
    });
}

function filtersAccordeons($, $postsFilter, $filterGroups) {
    const $triggers = $postsFilter.find('.js-display-more');
    $triggers.on('click', function(e) {
        e.preventDefault();
        $(this).closest($filterGroups).find('.js-hide').toggleClass('active');
    });
}

function postsAjax($, $postsAjax, $postsFilter, $filterGroups, $loadMore) {

    if (!$postsAjax.length) return;
    
    const $body = $('body');
    const $params = $postsFilter.find('.js-param');
    const $checkAlls = $postsFilter.find('.js-all');
    const $datePickers = $postsFilter.find('.js-datepicker');
    const $clearBtn = $postsAjax.find('.js-clear');
    const $searchForm = $('.js-search-form');
    const $searchFormInput = $searchForm.find('.js-search-input');
    const $searchFormReset = $searchForm.find('.js-search-reset');
    const postsNumber = parseInt(postsAjaxData.postsNumber)
    const loadMoreNumber = parseInt(postsAjaxData.loadMoreNumber);
    const $postsContainer = $postsAjax.find('.js-posts');

    let offset = 0;
    let isLoading = false;
    function queryKeys() {
        return {
            'search' : '',
            'metaLanguage' : [],
            'metaLanguages' : [],
            'taxCategories' : [],
            'taxDocumentsCategories' : [],
            'taxSections' : [],
            'taxServicesCategories' : [],
            'taxToolsCategories' : [],
            'eventDateFrom' : '',
            'eventDateTo' : '',
            'postDateFrom' : '',
            'postDateTo' : '',
            'metaEventsCategories' : []
        }
    }
    let query = queryKeys();


    datePickersInit( $datePickers );

    filtersInit();

    filtersClearInit();

    searchFormInit();

    loadMoreInit();

    /*-----------------------------------------------------------------------------------------*/
    /* PostsAjax watchers */
    /*-----------------------------------------------------------------------------------------*/

    function filtersInit() {

        $datePickers.on('change', function() {

            smoothScrollTo($('#posts-top'), µSpacer(6) );

            const $this = $(this);
    
            offset = 0;

            updatePosts();
    
        });

        $checkAlls.on('change', function() {

            smoothScrollTo($('#posts-top'), µSpacer(6) );
    
            offset = 0;
            const $checkAll = $(this);
            const $inputs = $checkAll.closest($filterGroups).find($params);
            if ( $checkAll.prop('checked') ) $inputs.prop('checked', false);
    
            updatePosts();
    
        });
    
        $params.on('change', function() {
    
            smoothScrollTo($('#posts-top'), µSpacer(6) );
    
            offset = 0;
    
            const $checkAll = $(this).closest($filterGroups).find($checkAlls);
            if ( $checkAll.prop('checked') ) $checkAll.prop('checked', false);
    
            updatePosts();
    
        });

    }

    function filtersClearInit() {

        $clearBtn.on('click', function(e) {

            smoothScrollTo($('#posts-top'), µSpacer(6) );
    
            e.preventDefault();
    
            let query = queryKeys();
    
            $params.prop('checked', false);
            $checkAlls.prop('checked', true);
            $datePickers.val('');
            $params.filter('[value="all"]').prop('checked', true);
    
            if ( "currentLanguage" in postsAjaxData ) {
                $params.filter('[value="'+postsAjaxData.currentLanguage+'"]').prop('checked', true);
            }
    
            updatePosts();
    
        });

    }

    function searchFormInit() {

        $searchForm.on('submit', function(e) {

            e.preventDefault();
    
            offset = 0;
            query.search = $searchFormInput.val();
    
            updatePosts();
    
        });
    
        $searchFormReset.on('click', function(e) {
    
            e.preventDefault();
    
            offset = 0;
            $searchFormInput.val('');
    
            $searchForm.submit();
    
        });

    }

    function loadMoreInit() {

        $(document).on( 'scroll', function() {

            $loadMore.inViewport(function(px) {

                if ( !$loadMore.hasClass('disabled') && (px > 0) && !isLoading ) {

                    isLoading = true;
                    offset = ( offset === 0 ) ? postsNumber : offset + loadMoreNumber;

                    updatePosts( false, function () {
                        isLoading = false;
                    });

                }

            });

        });

    }

    function updatePosts( loadingClass = true, callback ) {

        if ( loadingClass ) $postsAjax.addClass('loading');
        let noFilters = true;

        if ( query.search.length ) {
            $('.js-search-reset').addClass('active');
        }
        else {
            $('.js-search-reset').removeClass('active');
        }

        /* Get date filters */

        $datePickers.each( function (key, datePickers ) {

            const $datePicker = $(datePickers);
            const type = $datePicker.data('type');
            query[type] = $datePicker.val();

        });

        /* Get tax and meta filters */

        $filterGroups.each( function (key, filterGroup ) {

            const $filterGroup = $(filterGroup);
            let hasChecked = false;
            const type = $filterGroup.data('type');

            $filterGroup.find($params).each( function (key, param ) {

                const $param = $(param);

                if ( type in query ) {
                    if ( $param.prop('checked') && !$param.hasClass('js-default') ) {
                        hasChecked = true;
                        const paramValue = $param.val();
                        if ( !query[type].includes(paramValue) ) {
                            query[type].push(paramValue);
                        }
                    }
                    else {
                        query[type] = query[type].filter(item => item !== $param.val());
                    }
                }

            });

            if ( !hasChecked ) {
                $filterGroup.find($checkAlls).prop('checked', true);
            }
            else {
                noFilters = false;
            }

        });

        getPostsAjax( query, offset, postsNumber, function(res) {
            if ( res.success == true )  {
                setCookieObj( 'filter-'+postsAjaxData.postType, query);
                removeUnavailableFilters(res);
                if ( (res.data.offset + loadMoreNumber) >= res.data.foundPosts ) {
                    $loadMore.addClass('disabled');
                }
                else {
                    $loadMore.removeClass('disabled');
                }
                offset ? $postsContainer.append(res.data.html) : $postsContainer.html(res.data.html);
                $clearBtn.toggleClass('hidden', noFilters);
                $postsAjax.removeClass('loading');
                if ( callback ) callback();
            }
            else {
                //console.log(res);
            }
        });

    }


    function removeUnavailableFilters(res) {

        $filterGroups.each( function (key, filterGroup ) {

            const $filterGroup = $(filterGroup);
            const type = $filterGroup.data('type');

            if ( type in res.data.availableFilters ) {
                $filterGroup.find($params).each( function (key, param ) {

                    const $param = $(param);
                    const paramValue = $param.val();
                    const formatedParamValue = isNaN(paramValue) ? paramValue : parseInt(paramValue);
                    const $checkboxeGroup = $param.closest('.js-checkbox-group');


                    if ( !res.data.availableFilters[type].includes(formatedParamValue) ) {
                        //console.log(res.data.availableFilters[type]);
                        //console.log(paramValue);
                        $checkboxeGroup.addClass('disabled');
                    }
                    else {
                        $checkboxeGroup.removeClass('disabled');
                    }

                });
            }

        });

    }


}

/*-----------------------------------------------------------------------------------------*/
/* FUNCTIONS */
/*-----------------------------------------------------------------------------------------*/


function getPostsAjax( query, offset, postsNumber, callback ) {
    $.ajax({
        url: postsAjaxData.adminAjaxUrl,
        type: "POST",
        cache: false,
        data: {
            action: 'get_posts_ajax',
            query: query,
            offset: offset,
            postsNumber : postsNumber,
            postType : postsAjaxData.postType,
        },
        success: function(res) {
            callback(res);
        },
        error: function(res) {
            console.log(res);
        }
    });
}